/**
 * @fileoverview JkgridwinComponent - 網格開窗元件
 * @description
 * 此元件提供資料網格與開窗功能，支援查詢、過濾、排序、分頁等功能。
 * 基於 AG Grid 實現，提供豐富的資料顯示與選擇功能。
 *
 * @author JK Team
 * @version 2.0.0 - Upgraded to Angular 20
 */
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';

import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
  Input,
  Output,
} from '@angular/core';
import { AgGridService, JkBaseComponent, OpenWinLoadOption } from 'jk-service';
import { CommonModule } from '@angular/common';
import {
  CellClickedEvent,
  CellValueChangedEvent,
  ColDef,
  GridApi,
  GridReadyEvent,
  RowClickedEvent,
  RowDoubleClickedEvent,
  RowEditingStartedEvent,
  RowEditingStoppedEvent,
  RowSelectedEvent,
  RowSelectionOptions,
} from 'ag-grid-community';
import { MaterialModule } from 'jk-service';
import { jkLib } from 'jk-service';
import { JkeditComponent } from 'jk-service';
import { openWinClass } from 'jk-service';
import { FormsModule } from '@angular/forms';
import { JkGridBaseComponent } from '../jkgrid-base.component';

/**
 * @component JkgridwinComponent
 * @description
 * 網格開窗元件，提供資料顯示、選擇與查詢功能。
 * 此元件基於 AG Grid 實現，支援單選或多選模式，
 * 可用於資料查詢、列表顯示和彈出選擇等場景。
 * @extends {JkBaseComponent}
 */
@Component({
  selector: 'app-jkgridwin',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(window:resize)': 'onWindowResize()',
  },
  imports: [
    CommonModule,
    FormsModule,
    AgGridModule,
    JkeditComponent,
    //JkGridBaseComponent,
    MaterialModule,
  ],
  templateUrl: './jkgridwin.component.html',
  styles: [],
  providers: [AgGridService],
})
export class JkgridwinComponent extends JkGridBaseComponent {
  /**
   * @property {string} comType - 元件類型
   * @override
   */
  override comType: string = 'jkgridwin';
  /**
   * @method openwinItemStr
   * @returns {string} 開窗項目字串，格式為 "主表-項目-類型"
   */


  // Convert @Input() to input() signals
  //programId = input<string>('');


  /**
   * @method setProgramId
   * @description 設置 programId 的值
   * @param value - 要設置的 programId 值
   */
  /* Internal properties
  _programId: string = '';
  setProgramId(value: string): void {
    this._programId = value;
    this.programId.set(value);
  }*/


  isOk = output<boolean>();
  onOkClick = output<any>();
  expireDay = input<number>(0);
  //@Output()
  //afterGridReady: EventEmitter<JkgridwinComponent> =  new EventEmitter<JkgridwinComponent>();


  //columnDefs = input<ColDef[]>([]);
  //columnLabel = input<any>({});

  // TODO: Skipped for migration because:
  //  Class of this input is referenced in the signature of another class.
  @Input()
  columnLabel: any = {};

  constructor() {
    super();
    /*
    this.updateColumnsCount();
    effect(() => {
      const paramValue = this.params();
      // 在這裡處理參數變化 (如發送事件給父組件)
      this.valueChange.emit(paramValue);
    });*/
    /*
    // 響應式地監聽 itemListInput 變化並同步到 itemList
    effect(() => {
      const inputItems = this.itemListInput();
      if (inputItems !== undefined) {
        this._itemList.set(inputItems);
      }
    });*/
  }

  // Convert getter/setter for isMultiSelect


  get paramsStr(): string {
    let s = '';
    const params = this.params; //this._internalParams();
    for (let i = 0; i < params.length; i++) {
      s += jkLib.iif(s === '', '', ',') + params[i];
    }
    return s;
  }




  get pageSizeOptions(): number[] {
    const paginator = this.paginator;
    if (paginator) return paginator.pageSizeOptions;
    else return [5, 10, 20, 10000];
  }

  /*_itemData: any;
  set itemData(value: any) {
    this._itemData = value;
  }
  get itemData(): any {
    return this._itemData;
  }*/

  //_itemList = signal<Array<any>>([]);
  //list =  input<Array<any>>([]);

  okVisible: boolean = false;


  // Internal params state for handling updates to input signal
  //private _internalParams = signal<any[]>([]);



  override ngOnInit() {
    super.ngOnInit();
  }
  override ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.gridStyle = this.gridSrv.gridStyle;
    this.updateColumnsCount();
    // itemListInput 的同步現在由 constructor 中的 effect 處理
    // 無需手動賦值，effect 會自動響應變化
  }





  columnsAddSummary(columnDefs: ColDef<any, any>[]) {
    // this.columnDefs 是數值欄位在最後一筆加上總計
    for (let i = 0; i < columnDefs.length; i++) {
      if (columnDefs[i].cellDataType === 'number') {
        columnDefs[i].aggFunc = 'sum'; // 在最後一欄顯示總和. 這是enterprise 版本才有的功能
      }
    }
  }


  doQuery2(
    mainTable: string,
    item: string,
    type: string,
    where: string,
    order?: string,
    params?: any[]
  ) {
    this.maintable = mainTable;
    this.mainItem = item;
    this.type = type;
    this.where = where;
    this.order = order ? order : '';

    if (type.length > 2) {
      alert('doQuery2 type 長度不可超過2');
      return;
    }
    if (params) {
      //this._internalParams.set(params);
      this.paramsChange.emit(params);
    }
    this.doQuery();
  }
  doQuery3(openwinIn: openWinClass) {
    this.maintable = openwinIn.mainTable;
    this.mainItem = openwinIn.item;
    this.type = openwinIn.type;
    this.where = openwinIn.where;
    this.order = openwinIn.order;
    this.doQuery();
  }
  doQuery() {
    // where: string, order: string, params: any[]
    /*if (where) {
      this.where = where;
    }
    if (order) {
      this.order = order;
    }
    if (params) {
      //this._internalParams.set(params);
      //this._params = params;
      this.paramsChange.emit(params);
    }*/
    if (this.where !== '' && this.type === 'W') {
      this.page.showAlert('開窗條件type= W 不可有 where.改用 type=V');
    }
    if (this.keyExpr.length > 0 && this.valueExpr() === '') {
      console.warn(
        'Warning: keyExpr is set but valueExpr is empty. This may cause issues with data binding.'
      );
      // Note: Consider emitting an event or throwing an error here depending on requirements
    }
    let opt: OpenWinLoadOption = this.openwinIn.getOpenWinLoadOption();
    this.getColumnDefs(opt);
  }



  async openwin(winIn: openWinClass) {
    this.maintable = winIn.mainTable;
    this.mainItem = winIn.item;
    this.type = winIn.type;
    this.paramIn = [...winIn.params];
    this.where = winIn.where;
    this.order = winIn.order;
    this.doQuery();
  }
  override onKeydown(event: KeyboardEvent) {
    super.onKeydown(event);
    if (event.ctrlKey && event.shiftKey && event.key === 'F') {
      this.doFilter('');
      event.preventDefault();
    }
  }





  onBtStopEditing() {
    this.gridApi.stopEditing();
  }

  onBtStartEditing() {
    this.gridApi.setFocusedCell(1, 'make');
    this.gridApi.startEditingCell({
      rowIndex: this.focusedRowIndex,
      colKey: this.focusedRowKey,
    });
  }

  onEdit(params: any) {
    if (!this.isEditing) {
      this.isEditing = true;
      this.focusedRowIndex = params.node.rowIndex;
      this.selectedItem = { ...params.data };
      params.node.setSelected(true);
      this.gridApi.startEditingCell({
        rowIndex: params.node.rowIndex,
        colKey: 'name',
      });
      this.gridApi.redrawRows();
    }
  }

  onCellClicked(event: CellClickedEvent) {
    if (this.isEditing && event.node.rowIndex !== this.focusedRowIndex) {
      event.node.setSelected(false);
    }
  }

  onSave() {
    if (this.isEditing) {
      this.gridApi.stopEditing();
      const updatedRow = this.gridApi.getRowNode(
        this.focusedRowIndex.toString()
      )?.data;
      const updatedList = [...this.itemList];
      updatedList[this.focusedRowIndex] = { ...updatedRow };
      this.setItemList(updatedList);
      this.resetEditingState();
    }
  }

  onCancel() {
    if (this.isEditing) {
      const revertedList = [...this.itemList];
      revertedList[this.focusedRowIndex] = { ...this.selectedItem };
      this.setItemList(revertedList);
      this.resetEditingState();
    }
  }

  private resetEditingState() {
    this.isEditing = false;
    this.focusedRowIndex = -1;
    this.selectedItem = null;
    this.gridApi.redrawRows();
  }

}
